import React from 'react';

const Footer = () => {
    return (
        <footer
            style={{
                textAlign: 'center',
                width: '100vw',
                alignSelf: 'center',
                backgroundColor: '#009261',
                color: 'white',
                height: 'auto',
            }}>
            <div style={{ padding: 16 }}>
                Copyright ©PinT, Inc. All Rights Reserved.
            </div>
        </footer>
    );
};

export default Footer;